import React, { Component } from "react";

import View from "./View";

class FormContainer extends Component {
    render () {
        let {
            selectedData,
            formType
        } = this.props;

        switch (formType.toUpperCase()) {
            case "VIEW":
                return <View {...{ selectedData }}/>;
                break;
            default:
                return ";"
                break;
        }
    }
}

import {connect}            from 'react-redux';

function mapStateToProps(state) {
	var {
        selectedData,
        formType
	} = state.Kumulos;

	return {
        selectedData,
        formType
	};
}

export default connect(mapStateToProps)(FormContainer);


// WEBPACK FOOTER //
// ./components/Kumulos/FormContainer/index.js